var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dashboard-container" },
    [
      _vm.hasError
        ? _c(
            "v-alert",
            {
              staticClass: "mb-3 rounded-xl",
              attrs: { type: "error", dismissible: "" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.errorMessage || "Failed to load dashboard data") +
                  " "
              ),
            ]
          )
        : _vm._e(),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "h-100 rounded-xl pa-0 section-border",
                  attrs: { outlined: "", elevation: "0" },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "px-4", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "h-100 rounded-xl pa-0 transparent",
                                  attrs: { outlined: "", elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center px-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [_vm._v("Asset Management Warnings")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "py-0 px-0" },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          staticClass: "rounded-lg",
                                          attrs: {
                                            prominent: "",
                                            type: "error",
                                            color: "orange",
                                            elevation: "0",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { align: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                { staticClass: "grow" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-h6 font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.assetManagementWarningsCount
                                                        ) + " Warnings"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                { staticClass: "shrink" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.rightDrawerForAssetManagementWarnings =
                                                            !_vm.rightDrawerForAssetManagementWarnings
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Warnings List ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "h-100 rounded-xl pa-0 transparent",
                                  attrs: { outlined: "", elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center px-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [_vm._v("Inspection & CA Warnings")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "py-0 px-0" },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          staticClass: "rounded-lg",
                                          attrs: {
                                            prominent: "",
                                            type: "error",
                                            color: "purple",
                                            elevation: "0",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { align: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                { staticClass: "grow" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-h6 font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.inspectionsAndCAWarningsCount
                                                        ) + " Warnings"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                { staticClass: "shrink" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.rightDrawerForInspectionsAndCAWarnings =
                                                            !_vm.rightDrawerForInspectionsAndCAWarnings
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Warnings List ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "h-100 rounded-xl pa-0 transparent",
                                  attrs: { outlined: "", elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center px-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [_vm._v("IoT Warnings")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "py-0 px-0" },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          staticClass: "rounded-lg",
                                          attrs: {
                                            prominent: "",
                                            type: "error",
                                            color: "red",
                                            elevation: "0",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { align: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                { staticClass: "grow" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-h6 font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.iotWarningsCount
                                                        ) + " Warnings"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                { staticClass: "shrink" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.rightDrawerForIotWarnings =
                                                            !_vm.rightDrawerForIotWarnings
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Warnings List ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "6" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "h-100 rounded-xl pa-0 section-border",
                  attrs: { elevation: "0" },
                },
                [
                  _c(
                    "v-card-text",
                    { staticStyle: { "padding-top": "16px" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _vm._l(
                            _vm.areasAndEquipmentsDashboardCards,
                            function (stat, index) {
                              return [
                                _c(
                                  "v-col",
                                  { key: index, attrs: { cols: "4", sm: "4" } },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass: "stat-card rounded-lg",
                                        attrs: { outlined: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "text-h5 font-weight-bold mb-1",
                                                  },
                                                  [_vm._v(_vm._s(stat.value))]
                                                ),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(_vm._s(stat.label)),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-avatar",
                                              {
                                                staticClass:
                                                  "d-flex align-center justify-center rounded-md",
                                                attrs: {
                                                  tile: "",
                                                  size: "37",
                                                  color: stat.color || "grey",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "24",
                                                      color:
                                                        stat.iconColor ||
                                                        "white",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(stat.icon))]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            }
                          ),
                          _c(
                            "v-col",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { cols: "6" },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "transparent rounded-xl",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center pa-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [_vm._v("Gas Area Equipments Count")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "h-100 rounded-lg pa-0",
                                          attrs: { outlined: "" },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            { staticClass: "pa-0" },
                                            [
                                              _c(
                                                "dust-area-equipments-count-chart",
                                                {
                                                  attrs: {
                                                    "chart-data":
                                                      _vm.gasAreaEquipmentsCountChartData,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { cols: "6" },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "transparent rounded-xl",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center pa-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [_vm._v("Dust Area Equipments Count")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "h-100 rounded-lg pa-0",
                                          attrs: { outlined: "" },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            { staticClass: "pa-0" },
                                            [
                                              _c(
                                                "dust-area-equipments-count-chart",
                                                {
                                                  attrs: {
                                                    "chart-data":
                                                      _vm.dustAreaEquipmentsCountChartData,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "transparent rounded-xl",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center pa-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [
                                          _vm._v(
                                            "Equipment & Area Count According to Time"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "rounded-lg",
                                          attrs: { outlined: "" },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "areas-and-equipments-count-chart",
                                                {
                                                  attrs: {
                                                    "chart-data":
                                                      _vm.areasAndEquipmentsCountChartData,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "6" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "h-100 rounded-xl pa-0 section-border",
                  attrs: { outlined: "", elevation: "0" },
                },
                [
                  _c(
                    "v-card-text",
                    { staticStyle: { "padding-top": "16px" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", lg: "7" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "h-100 transparent rounded-xl pa-0",
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center pa-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "0px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [_vm._v("Inspections")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { dense: "" } },
                                        [
                                          _vm._l(
                                            _vm.inspectionsDashboardCards,
                                            function (stat, index) {
                                              return [
                                                _c(
                                                  "v-col",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      cols: "6",
                                                      sm: "6",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass:
                                                          "stat-card rounded-lg",
                                                        attrs: { outlined: "" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              "two-line": "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "text-h5 font-weight-bold mb-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        stat.value
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        stat.label
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-avatar",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-center justify-center rounded-md",
                                                                attrs: {
                                                                  tile: "",
                                                                  size: "37",
                                                                  color:
                                                                    stat.color ||
                                                                    "grey",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      size: "24",
                                                                      color:
                                                                        stat.iconColor ||
                                                                        "white",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        stat.icon
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", lg: "5" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "h-100 transparent rounded-xl pa-0",
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center pa-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [_vm._v("Corrective Actions")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list",
                                        {
                                          staticClass: "rounded-lg",
                                          attrs: { dense: "" },
                                        },
                                        [
                                          _vm._l(
                                            _vm.correctiveActionsDashboardCards,
                                            function (card, index) {
                                              return [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    key: index,
                                                    staticClass: "rounded-xl",
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-avatar",
                                                      {
                                                        staticClass:
                                                          "rounded-lg",
                                                        attrs: {
                                                          tile: "",
                                                          size: "45",
                                                          color:
                                                            card.color ||
                                                            "grey lighten-2",
                                                        },
                                                      },
                                                      [
                                                        card.icon
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    card.iconColor ||
                                                                    "grey darken-2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      card.icon
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-list-item-content", [
                                                      _c("h3", [
                                                        _vm._v(
                                                          _vm._s(card.overline)
                                                        ),
                                                      ]),
                                                    ]),
                                                    _c(
                                                      "v-list-item-content",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                      },
                                                      [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "text-h5 font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(card.value)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "transparent rounded-xl",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticClass: "d-flex align-center pa-0",
                                      staticStyle: {
                                        "padding-bottom": "0",
                                        "padding-top": "8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-overline-h6" },
                                        [
                                          _vm._v(
                                            "Inspection Questions Classification"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "rounded-lg",
                                          attrs: { outlined: "" },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "inspection-questions-classification-chart",
                                                {
                                                  attrs: {
                                                    "chart-data":
                                                      _vm.inspectionChartDataForFailPassNA,
                                                  },
                                                }
                                              ),
                                              _c(
                                                "inspection-questions-classification-chart",
                                                {
                                                  attrs: {
                                                    "chart-data":
                                                      _vm.inspectionChartDataForGrade,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "rounded-xl",
          attrs: {
            app: "",
            right: "",
            temporary: "",
            width: _vm.rightDrawerWidthForAssetManagementWarnings,
          },
          model: {
            value: _vm.rightDrawerForAssetManagementWarnings,
            callback: function ($$v) {
              _vm.rightDrawerForAssetManagementWarnings = $$v
            },
            expression: "rightDrawerForAssetManagementWarnings",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "h-100 rounded-xl", attrs: { outlined: "" } },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: { "padding-bottom": "0", "padding-top": "10px" },
                },
                [
                  _c("div", { staticClass: "text-h5" }, [
                    _vm._v(
                      _vm._s(_vm.assetManagementWarningsCount) +
                        " Asset Management Warnings"
                    ),
                  ]),
                ]
              ),
              _c(
                "v-card-text",
                { staticStyle: { "padding-top": "16px" } },
                [
                  _c("AssetManagementWarningsListComponent", {
                    attrs: { siteId: _vm.siteId },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "rounded-xl",
          attrs: {
            app: "",
            right: "",
            temporary: "",
            width: _vm.rightDrawerWidthForInspectionsAndCAWarnings,
          },
          model: {
            value: _vm.rightDrawerForInspectionsAndCAWarnings,
            callback: function ($$v) {
              _vm.rightDrawerForInspectionsAndCAWarnings = $$v
            },
            expression: "rightDrawerForInspectionsAndCAWarnings",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "h-100 rounded-xl", attrs: { outlined: "" } },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: { "padding-bottom": "0", "padding-top": "10px" },
                },
                [
                  _c("div", { staticClass: "text-h5" }, [
                    _vm._v(
                      _vm._s(_vm.inspectionsAndCAWarningsCount) +
                        " Inspection & CA Warnings"
                    ),
                  ]),
                ]
              ),
              _c(
                "v-card-text",
                { staticStyle: { "padding-top": "16px" } },
                [
                  _c("InspectionsAndCAWarningsListComponent", {
                    attrs: { siteId: _vm.siteId },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "rounded-xl",
          attrs: {
            app: "",
            right: "",
            temporary: "",
            width: _vm.rightDrawerWidthForIotWarnings,
          },
          model: {
            value: _vm.rightDrawerForIotWarnings,
            callback: function ($$v) {
              _vm.rightDrawerForIotWarnings = $$v
            },
            expression: "rightDrawerForIotWarnings",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "h-100 rounded-xl", attrs: { outlined: "" } },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: { "padding-bottom": "0", "padding-top": "10px" },
                },
                [
                  _c("div", { staticClass: "text-h5" }, [
                    _vm._v(_vm._s(_vm.iotWarningsCount) + " IoT Warnings"),
                  ]),
                ]
              ),
              _c(
                "v-card-text",
                { staticStyle: { "padding-top": "16px" } },
                [
                  _c("SiteWarningsListComponent", {
                    attrs: { siteId: _vm.siteId },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }